/**
 * Created by Klayer3
 */

import * as Rx from 'rxjs/Rx';

import {Http, Response} from '@angular/http';
import {ServiceBase} from './ServiceBase';
import {DTO, Entity} from '../entities/entities';
import {environment} from '../../../environments/environment';
import {ErrorService, ErrorType} from './error.service';
import {AuthService} from '../../auth/auth.service';
import {ResolverService} from './resolver.service';
import * as _ from 'lodash';
import {isNullOrUndefined} from 'util';
import {Observable} from 'rxjs/Observable';
import {isArray} from 'rxjs/util/isArray';

export interface PageSort{
  direction?: string;
  property?: string;
  ignoreCase?: boolean;
  nullHandling?: string;
  ascending?: boolean;
  descending?: boolean
}

export interface Page<T> {
  content: T[];
  last: boolean;
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
  first: boolean;
  sort?: PageSort[],
  numberOfElements: number;
  options?: any;
  url?: string;
}

export interface PageRequest{
  pageNumber?: number;
  pageSize?: number;
  pageSorting?: string;
  pageDirection?: string;
}

export abstract class HttpServiceBase<T extends Entity> extends ServiceBase<T> {
  protected onRemove(data: T): void {
    super.onRemove(data);
  }

  protected authService: AuthService = ResolverService.instance().getService('AuthService');

  public cleanObject(obj: any): any {
    if(obj){
      obj =  Object.keys(obj)
        .filter(k => !isNullOrUndefined(obj[k]) && 'null' != obj[k] && 'undefined' != obj[k] )
        .reduce((previousValue, k) => {
          previousValue[k]=obj[k];
          return previousValue;
        },{});
    }
    return obj;

  }

  // FIXME spostare il valore di dafault in environemt
  public isPaginated(): boolean {
    return false;
  }

  // FIXME spostare il valore di dafault in environemt
  public isSync(): boolean {
    return false;
  }

  // FIXME spostare il valore di dafault in environemt
  public getSyncTimeout(): number {
    return 15000;
  }

  protected getBasePath() {
    return environment.apiUrl;
  }

  protected get _url() {
    return this.getBasePath() + this.getUrl();
  }

  public abstract getUrl(): string;

  protected init() {
    if (this.isSync()) {
      if (this.authService.loggedIn) {
        this.sync();
      }
      this.authService.loginEvent.subscribe(() => {
          this.sync();
        }
      );
      this.authService.logoutEvent.subscribe(() => {
          this.setItems([]);
        }
      );

    } else {
      if (this.authService.loggedIn) {
        if(!this.refreshOnRouteChange())
          this.loadItems().subscribe();
      }
      this.authService.loginEvent.subscribe(() => {
        if(!this.refreshOnRouteChange())
          this.loadItems().subscribe();
        }
      );
      this.authService.logoutEvent.subscribe(() => {
          this.setItems([]);
        }
      );

    }




  }

  protected sync() {
    const me = this;
    if (me.authService.loggedIn) {
      me.list().subscribe(ret => me.merge(ret));
      setTimeout(function () {
        me.sync();
      }, me.getSyncTimeout());
    }
  }

  protected merge(ret: T[]) {
    const me = this;
    let curr_data = this.data;
    _.differenceBy(<T[]>curr_data, <T[]>ret, 'id').forEach(function (item) {
      me.onRemove(item);
    });
    curr_data = this.data;
    _.differenceBy(<T[]>ret, <T[]>curr_data, 'id').forEach(function (item) {
      me.onAddOrUpdate(item);
    });
    curr_data = this.data;
    _.differenceWith(<T[]>ret, <T[]>curr_data, _.isEqual).forEach(function (item) {
      me.onAddOrUpdate(item);
    });

  }

  constructor(protected http: Http) {
    super();
    this.init();
    this.onRouteChange();
    this.onDataChange();
  }

  public onRouteChange(){
    this.authService.routeChangeEvent.subscribe(() => {
      if(this.refreshOnRouteChange()) {
        this.setItems([]);
      }
    });
  }

  // FIXME K3 fare in modo che tutte le chiamate passino da qui
  public httpCall(metod: string, path?: string, body?: any) {
    const me = this;
    return Rx.Observable.create((observer: any) => {
      me.http[metod](path, body)
        .map(function (res: Response) {
          const body: DTO = <DTO> res.json();
          const err: Error = me.getError(body);
          if (err) {
            observer.throw(me.handleError(err, ErrorType.SUBMIT));
            return;
          }
          let ret = isNullOrUndefined(body.data) ? null : body.data;
          observer.next(ret);
        }).catch(error => observer.throw(me.handleError(error, ErrorType.HTTP))).subscribe();
    });
  }


  add(entity: T): Rx.Observable<T> {
    const me = this;


    return Rx.Observable.create((observer: any) => {
      me.http.post(me._url, me.fromEntity(entity))
        .map(function (res: Response) {
          const body: DTO = <DTO> res.json();
          const err: Error = me.getError(body);
          if (err) {
            observer.throw(me.handleError(err, ErrorType.SUBMIT));
            return;
          }
          observer.next(me.onAddOrUpdate(body.data || null));
        }).catch(error => observer.throw(me.handleError(error, ErrorType.HTTP))).subscribe();

    });

  }

  update(entity: T): Rx.Observable<T> {

    const me = this;

    return Rx.Observable.create((observer: any) => {
      me.http.put(this._url + '/' + entity.id, me.fromEntity(entity))
        .map(function (res: Response) {
          const body: DTO = <DTO> res.json();
          const err: Error = me.getError(body);
          if (err) {
            observer.throw(me.handleError(err, ErrorType.SUBMIT));
            return;
          }
          observer.next(me.onAddOrUpdate(body.data || null));
        }).catch(error => observer.throw(me.handleError(error, ErrorType.HTTP))).subscribe();

    });

  }

  remove(entity: T): Rx.Observable<T> {
    const me = this;
    const idx = this.getIndex(entity);

    if (idx !== -1) {
      return Rx.Observable.create((observer: any) => {
        this.http.delete(this._url + '/' + entity.id)
          .map(function (res: Response) {
            const body: DTO = <DTO> res.json();
            const err: Error = me.getError(body);
            if (err) {
              observer.throw(me.handleError(err, ErrorType.SUBMIT));
              return;
            }
            // const ret = me.fromJson(body.data || null);
            me.onRemove(entity);
            observer.next(null);
          }).catch(error => observer.throw(me.handleError(error, ErrorType.HTTP))).subscribe();

      });

    }

    return Rx.Observable.from([null]);
  }

  public refreshOnRouteChange() {
    return true;
  }

  public hasSingleGet(){
    return true;
  }



  load(entity: T, force?: boolean, add = true): Rx.Observable<T> {
    const me = this;
    const indx = this.getIndex(entity);

    if (indx !== -1 && !force) {
      return Rx.Observable.from([this.data[indx]]);
    } else {
      return Rx.Observable.create((observer: any) => {
        if(me.hasSingleGet()){
          me.http.get(this._url + '/' + entity.id)
            .map(function (res: Response) {
              const body: DTO = <DTO> res.json();
              const err: Error = me.getError(body);

              if (err) {
                observer.throw(me.handleError(err, ErrorType.SUBMIT));
                return;
              }
              observer.next( add ? me.onAddOrUpdate(body.data || null) : me.fromJson(body.data));
            }).catch(error => me.handleError(error, ErrorType.HTTP)).subscribe();
        } else {
          me.list().subscribe(ret => observer.next(me.onAddOrUpdate(ret.find( i => i.id == entity.id )|| null)));
        }
      });
    }
  }

  protected listJson(options?: any): Rx.Observable<any[]> {
    const me = this;
    return Rx.Observable.create((observer: any) => {
      this.http.get(this._url, {params: options})
        .map(function (res: Response) {
          const body: DTO = <DTO> res.json();
          const err: Error = me.getError(body);
          if (err) {
            observer.throw(me.handleError(err, ErrorType.SUBMIT));
            return;
          }
          observer.next(<any[]>body.data || null);
        }).catch(error => observer.throw(me.handleError(error, ErrorType.HTTP))).subscribe();
    });
  }

  public list(options?: any): Rx.Observable<T[]> {
    const me = this;

    return Rx.Observable.create((observer: any) => {
      me.listJson(options).catch(er => observer.throw(er)).subscribe(data => observer.next(me.fromJsonArray(<any[]>data)));
    });
  }


  public loadItems(options?: any): Rx.Observable<T[]> {
    const me = this;
    if(this.isPaginated()){
      return Rx.Observable.create((observer: any) => {
       me.loadPage(options).subscribe(ret => observer.next(ret.content));
      });
    }else {
      return Rx.Observable.create((observer: any) => {
        me.listJson(options).catch(er => observer.throw(er)).subscribe(data => observer.next(me.setItems(me.fromJsonArray(<any[]>data))));
      });
    }

  }

  public loadPage(options?: any, page?: PageRequest, url?: string): Observable<Page<T>> {
    const me = this;
    if( !page)
       page= this.getPageRequest();
    if(options || page)
     options =  Object.assign({}, options, page);

    return Rx.Observable.create((observer: any) => {
      me.httpCall('get', url ? url : me._url , {params: options} ).subscribe( ret => {

        if(ret) {
          const pageRet: Page<T> = <Page<T>> ret;
          if( isArray(ret.sort) ){
            // vecchie api
          } else {
            if ( options.pageSorting && ret.sort && ret.sort.sorted ){
              ret.sort = [
                {direction: options.pageDirection,
                  property: options.pageSorting,
                  ascending: !options.pageDirection || options.pageDirection == 'ASC',
                  descending: options.pageDirection === 'DESC'
                }
               ];
            }
          }
          ret.options = options;

          ret.content = me.setItems(pageRet.content);

          ret.url = url;
          observer.next(pageRet);
        }else {
          observer.next({ content:[]});
        }
      });
    });

  }

  public getPageRequest(page?: Page<T>): PageRequest{
    const pageNumber: number = page ? page.number : environment.constants.pageFirst;
    const pageSize: number = page ? page.size : environment.constants.pageSize;
    const pageDirection: string = page && page.sort && page.sort.length > 0 ?  (page.sort[0].descending ? 'DESC' : 'ASC')  : undefined;
    const pageSorting: string = page && page.sort && page.sort.length > 0 ?  page.sort[0].property : undefined;
    const pr: PageRequest = { pageNumber: pageNumber, pageSize: pageSize, pageDirection: pageDirection, pageSorting: pageSorting};
    return pr;
  }

  public nextPage(page: Page<T>): Observable<Page<T>>{
    const me = this;
    return Rx.Observable.create((observer: any) => {
      if( page.last){
        observer.next(page);
      }else{
        const pr: PageRequest = me.getPageRequest(page);
        pr.pageNumber++;
        me.loadPage(page.options, pr, page.url).subscribe(p => observer.next(p));
      }
    });
  }

  public previousPage(page: Page<T>): Observable<Page<T>>{
    const me = this;
    return Rx.Observable.create((observer: any) => {
      if( page.last){
        observer.next(page);
      }else{
        const pr: PageRequest = me.getPageRequest(page);
        pr.pageNumber++;
        me.loadPage(page.options, pr, page.url).subscribe(p => observer.next(p));
      }
    });
  }

  public setOrder(page: Page<T>, field: string){
    if (!page) return ;
    let currSort: PageSort = {};
    if(page && page.sort && page.sort.length > 0){
      currSort = page.sort[0];
    }
    if(currSort.property == field)
        if(currSort.ascending){
            currSort.descending = currSort.ascending;
            currSort.ascending = false;
        } else {
          page.sort=[];
    } else {
      page.sort=[{property: field, ascending: true, descending : false}];
    }
  }

  public getOrder(page: Page<T>, field: string): string {
    let currSort: PageSort = {};

    if(page && page.sort && page.sort.length > 0) {
     currSort = page.sort[0];
    }

    return currSort.property == field ? (currSort.ascending ? 'ASC' : 'DESC') : null;

  }

  public toPage(page: Page<T>, num: number): Observable<Page<T>>{
    const me = this;
    return Rx.Observable.create((observer: any) => {
      if( page && ( page.totalPages < num || num < 0 )) {
        observer.next(page);
      }else{

        const pr: PageRequest = me.getPageRequest(page);
        pr.pageNumber= num;
        me.loadPage(!isNullOrUndefined(page) ? page.options : null, pr, !isNullOrUndefined(page) ? page.url : null).subscribe(p => observer.next(p));
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/HttpServiceBase.ts